import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./admins_profiles.css";
import SideBar from "../Components/SideBar.js";
import { API_BASE_URL } from "../config.js";

export default function AdminsProfiles() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAdmin = async () => {
      const token = localStorage.getItem("access_token");

      if (!token) {
        navigate("/login");
        return;
      }

      try {
        setLoading(true);
        setError("");

        const baseUrl =
          API_BASE_URL || "http://127.0.0.1:8000/api";

        const response = await fetch(
          `${baseUrl}/users/${id}/`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();

        console.log("ADMIN PROFILE:", data);

        if (!response.ok) {
          throw new Error(
            data?.detail || "فشل في جلب بيانات المدير"
          );
        }

        setAdmin(data);
      } catch (err) {
        console.error("Admin profile error:", err);
        setError("تعذر تحميل بيانات المدير.");
      } finally {
        setLoading(false);
      }
    };

    fetchAdmin();
  }, [id, navigate]);

  if (loading) {
    return (
      <div
        className="flex items-center justify-center min-h-screen"
        dir="rtl"
      >
        <div className="text-center">
          <i className="fa-solid fa-spinner fa-spin text-4xl mb-4"></i>
          <p>جاري تحميل بيانات المدير...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className="flex items-center justify-center min-h-screen"
        dir="rtl"
      >
        <div className="text-center">
          <i className="fa-solid fa-circle-exclamation text-4xl mb-4"></i>
          <p>{error}</p>

          <button
            onClick={() => navigate("/all-admins")}
            className="mt-4"
          >
            العودة إلى قائمة المدراء
          </button>
        </div>
      </div>
    );
  }

  if (!admin) {
    return null;
  }

  return (
    <div className="profile-wrapper" dir="rtl">

      {/* SIDEBAR */}
      <SideBar role="admin" />

      <main className="profile-main-content">

        {/* HEADER */}
        {/* HEADER */}
<div 
  className="profile-header-card" 
  style={{ 
    display: "flex", 
    alignItems: "center", 
    justifyContent: "flex-start", 
    gap: "2rem",
    padding: "3rem 2.5rem", 
    minHeight: "160px" 
  }}
>

  <div className="header-icon" style={{ fontSize: "3.5rem", padding: "1rem" }}>
    <i className="fa-solid fa-user-shield"></i>
  </div>

  <div className="header-info" style={{ textAlign: "right" }}>
    <p className="subtitle" style={{ fontSize: "1.1rem", opacity: "0.9", marginBottom: "0.5rem" }}>
      الملف الشخصي للمدير
    </p>

    <h1 className="admin-name" style={{ fontSize: "2.6rem", fontWeight: "800", margin: "0 0 0.7rem 0" }}>
      {admin.real_name || "بدون اسم"}
    </h1>

    <span className="admin-badge" style={{ fontSize: "1rem", padding: "0.5rem 1.2rem" }}>
      مدير النظام
    </span>
  </div>

</div>
        {/* PERSONAL INFORMATION */}
        {/* PERSONAL INFORMATION */}
<section className="profile-card">

  <h3 className="card-title">
    <i className="fa-solid fa-user"></i>
    المعلومات الشخصية
  </h3>

  <div className="form-grid">

    {/* NAME */}
    <div className="input-group">
      <label>الاسم الكامل</label>
      <div className="input-wrapper">
        <i className="fa-solid fa-address-card icon"></i>
        <input
          type="text"
          value={admin.real_name || ""}
          readOnly
          placeholder="غير متوفر"
        />
      </div>
    </div>


    {/* USERNAME */}
    <div className="input-group">
      <label>اسم المستخدم</label>
      <div className="input-wrapper">
        <i className="fa-solid fa-user icon"></i>
        <input
          type="text"
          value={admin.username || ""}
          readOnly
          placeholder="غير متوفر"
        />
      </div>
    </div>


    {/* PHONE */}
    <div className="input-group">
      <label>رقم الهاتف</label>
      <div className="input-wrapper">
        <i className="fa-solid fa-phone icon"></i>
        <input
          type="tel"
          value={admin.phon_number || ""}
          readOnly
          placeholder="غير متوفر"
        />
      </div>
    </div>


    {/* EMAIL */}
    <div className="input-group">
      <label>البريد الإلكتروني</label>
      <div className="input-wrapper">
        <i className="fa-solid fa-envelope icon"></i>
        <input
          type="email"
          value={admin.email || ""}
          readOnly
          placeholder="غير متوفر"
        />
      </div>
    </div>


    {/* ROLE */}
    <div className="input-group">
      <label>نوع الحساب</label>
      <div className="input-wrapper">
        <i className="fa-solid fa-user-shield icon"></i>
        <input
          type="text"
          value="مدير"
          readOnly
        />
      </div>
    </div>


    {/* ACCOUNT ID */}
    <div className="input-group">
      <label>رقم المدير</label>
      <div className="input-wrapper">
        <i className="fa-solid fa-hashtag icon"></i>
        <input
          type="text"
          value={admin.id || ""}
          readOnly
        />
      </div>
    </div>

  </div>

</section>


        {/* ACCOUNT INFORMATION */}
<section className="profile-card">

  <h3 className="card-title">
    <i className="fa-solid fa-shield-halved"></i>
    معلومات الحساب
  </h3>

  <div className="account-info-grid">

    <div className="account-info-item">
      <div className="account-info-icon">
        <i className="fa-solid fa-user-shield"></i>
      </div>
      <div className="account-info-text">
        <span className="info-label">الدور</span>
        <strong className="info-value">مدير</strong>
      </div>
    </div>

    <div className="account-info-item">
      <div className="account-info-icon">
        <i className="fa-solid fa-envelope-circle-check"></i>
      </div>
      <div className="account-info-text">
        <span className="info-label">البريد الإلكتروني</span>
        <strong className="info-value">
          {admin.email_verified ? "تم التحقق" : "غير متحقق"}
        </strong>
      </div>
    </div>

    <div className="account-info-item">
      <div className="account-info-icon">
        <i className="fa-solid fa-id-card"></i>
      </div>
      <div className="account-info-text">
        <span className="info-label">معرّف الحساب</span>
        <strong className="info-value">#{admin.id}</strong>
      </div>
    </div>

  </div>

</section>


        {/* ACTIONS */}
        <div className="profile-actions">

          <button
            className="btn-secondary"
            onClick={() => navigate("/all-admins")}
          >
            <i className="fa-solid fa-arrow-right"></i>
            العودة إلى المدراء
          </button>

        </div>

      </main>

    </div>
  );
}